// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"473":"b6f8e4fd","787":"d0659d85"}[chunkId] + ".chunk.js";
};